

// ok v1.1 make it video instead of img
import React from 'react';

// Placeholder data - Updated contentUrl to video, added posterUrl
const reelData = {
  id: 1,
  // --- Use VIDEO URL for contentUrl ---
  contentUrl: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  // Use previous image URL as the poster (shown while loading)
  posterUrl: 'https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0440_florence_giordano-poloni_final_header-768x512.jpg',
  // --- Keep other data fields ---
  userImageUrl: 'https://cdn.theculturetrip.com/wp-content/uploads/2019/04/location-page-header-prague-greta-samuel-768x512.jpg',
  username: '@TOMORROW X TOGETHER',
  caption: "Let's keep dancing until the sun rises 🌅 ... more",
  soundImageUrl: 'https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0378_hong-kong_jisu-choi_final_header-1-768x512.jpg',
  soundTitle: 'Deja Vu Official MV - TXT',
  likeCount: '290.5K',
  commentCount: '100K',
  saveCount: '89K',
  shareCount: '132.5K',
};

// Simple Icon Placeholder Component (replace with actual SVGs/Icons) - Unchanged
const IconPlaceholder = ({ label, count }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
    <div style={{
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      marginBottom: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '10px',
      color: 'white'
    }}>
      {label}
    </div>
    {count && <span style={{ color: 'white', fontSize: '12px', fontWeight: 'bold', textShadow: '1px 1px 2px rgba(0,0,0,0.7)' }}>{count}</span>}
  </div>
);

// Rotating Sound Icon Placeholder - Unchanged
const SoundIconPlaceholder = ({ imageUrl }) => (
    <div style={{
        width: '45px',
        height: '45px',
        borderRadius: '50%',
        border: '2px solid rgba(255, 255, 255, 0.5)',
        padding: '3px',
        marginTop: '10px'
    }}>
        <img
            src={imageUrl}
            alt="Sound cover"
            style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
        />
    </div>
);


// Main Reel Component - Now uses <video>
function ReelDisplay({ data = reelData }) {

  const styles = { // Styles remain largely the same
    reelContainer: {
      width: '100%',
      maxWidth: '450px',
      height: '700px',
      backgroundColor: '#111', // Changed to dark background for video
      margin: '20px auto',
      position: 'relative',
      overflow: 'hidden',
      borderRadius: '10px',
    },
    reelContent: { // This style now applies to the <video>
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover', // Make video cover the area
      zIndex: 1,
    },
    overlay: {
      position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
      zIndex: 2, display: 'flex',
    },
    topNav: {
       position: 'absolute', top: '15px', left: 0, width: '100%', display: 'flex',
       justifyContent: 'center', gap: '15px', color: 'rgba(255, 255, 255, 0.7)',
       fontWeight: 'bold', fontSize: '16px', textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
    },
    sidebar: {
      position: 'absolute', bottom: '15px', right: '10px', display: 'flex',
      flexDirection: 'column', alignItems: 'center',
    },
    bottomInfo: {
       position: 'absolute', bottom: '15px', left: '15px', right: '80px',
       color: 'white', textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
    },
    username: {
      fontWeight: 'bold', fontSize: '16px', marginBottom: '5px', display: 'flex',
      alignItems: 'center', gap: '5px'
    },
    caption: {
      fontSize: '14px', marginBottom: '10px', lineHeight: '1.3',
    },
    soundInfo: {
      display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px',
    }
  };

  return (
    <div style={styles.reelContainer}>

      {/* --- Background Video --- */}
      {/* Replaced <img> with <video> */}
      <video
        key={data.id} // Use key if data might change, helps React update element
        src={data.contentUrl} // Use the video URL from data
        poster={data.posterUrl} // Use the poster image URL
        style={styles.reelContent} // Apply styles to fill container
        autoPlay // Start playing automatically
        muted    // Mute audio (often required for autoplay)
        loop     // Repeat the video
        playsInline // Important for playback on iOS without going fullscreen
        // controls={false} // Hides default browser video controls
      >
        Your browser does not support the video tag. {/* Fallback text */}
      </video>
      {/* --- End Background Video --- */}


      {/* Overlays Container (Unchanged) */}
      <div style={styles.overlay}>

        {/* Optional: Simplified Top Navigation (Unchanged) */}
        <div style={styles.topNav}>
            <span>Following</span>
            <span>For You</span>
        </div>


        {/* Bottom Info Overlay (Unchanged) */}
        <div style={styles.bottomInfo}>
          <div style={styles.username}>
            <span>{data.username}</span>
          </div>
          <div style={styles.caption}>
            {data.caption}
          </div>
          <div style={styles.soundInfo}>
             <span>🎵</span>
             <span>{data.soundTitle}</span>
          </div>
        </div>

        {/* Right Sidebar Overlay (Unchanged) */}
        <div style={styles.sidebar}>
           <div style={{ position: 'relative', marginBottom: '20px' }}>
              <img src={data.userImageUrl} alt="User profile" style={{ width: '50px', height: '50px', borderRadius: '50%', border: '2px solid white' }} />
              <div style={{
                 position: 'absolute', bottom: '-8px', left: '50%', transform: 'translateX(-50%)',
                 width: '20px', height: '20px', borderRadius: '50%', backgroundColor: 'red', color: 'white',
                 display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', fontWeight: 'bold',
                 border: '1px solid white'
              }}>+</div>
           </div>

           <IconPlaceholder label="❤️" count={data.likeCount} />
           <IconPlaceholder label="💬" count={data.commentCount} />
           <IconPlaceholder label="💾" count={data.saveCount} />
           <IconPlaceholder label="➤" count={data.shareCount} />

           <SoundIconPlaceholder imageUrl={data.soundImageUrl} />
        </div>

      </div>
    </div>
  );
}

export default ReelDisplay;


// // v1.0 ok
// import React from 'react';

// // Placeholder data - Replace with props or state in a real app
// const reelData = {
//   id: 1,
//   // Use a relevant image URL for the background
//   // Using a generic placeholder here, replace with reel.jpg if accessible via URL
//   // or import it if using a bundler like Webpack/Vite
//   // import reelBg from './path/to/reel.jpg'; <--- Example import
//   contentUrl: 'https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0440_florence_giordano-poloni_final_header-768x512.jpg', // Replace with actual reel.jpg URL or imported variable
//   userImageUrl: 'https://cdn.theculturetrip.com/wp-content/uploads/2019/04/location-page-header-prague-greta-samuel-768x512.jpg',
//   username: '@TOMORROW X TOGETHER', // From image
//   caption: "Let's keep dancing until the sun rises 🌅 ... more", // From image
//   soundImageUrl: 'https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0378_hong-kong_jisu-choi_final_header-1-768x512.jpg',
//   soundTitle: 'Deja Vu Official MV - TXT', // From image
//   likeCount: '290.5K', // From image
//   commentCount: '100K', // From image
//   saveCount: '89K', // Assuming the bookmark icon is 'saves'
//   shareCount: '132.5K', // From image
// };

// // Simple Icon Placeholder Component (replace with actual SVGs/Icons)
// const IconPlaceholder = ({ label, count }) => (
//   <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
//     <div style={{
//       width: '40px',
//       height: '40px',
//       borderRadius: '50%',
//       backgroundColor: 'rgba(255, 255, 255, 0.2)', // Placeholder icon bg
//       marginBottom: '5px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       fontSize: '10px', // Make text small if using label
//       color: 'white'
//     }}>
//       {/* In real app, use SVG or Icon Font here */}
//       {label}
//     </div>
//     {count && <span style={{ color: 'white', fontSize: '12px', fontWeight: 'bold', textShadow: '1px 1px 2px rgba(0,0,0,0.7)' }}>{count}</span>}
//   </div>
// );

// // Rotating Sound Icon Placeholder
// const SoundIconPlaceholder = ({ imageUrl }) => (
//     <div style={{
//         width: '45px',
//         height: '45px',
//         borderRadius: '50%',
//         border: '2px solid rgba(255, 255, 255, 0.5)',
//         padding: '3px',
//         marginTop: '10px' // Add some space above it
//         // Add animation in real CSS for rotation
//     }}>
//         <img
//             src={imageUrl}
//             alt="Sound cover"
//             style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
//         />
//     </div>
// );


// // Main Reel Component
// function ReelDisplay({ data = reelData }) { // Default to placeholder data

//   const styles = {
//     reelContainer: {
//       width: '100%', // Or fixed width like '350px' to simulate phone
//       maxWidth: '450px', // Max width for larger screens
//       height: '700px', // Fixed height to simulate phone screen aspect ratio
//       backgroundColor: '#111', // Fallback background
//       margin: '20px auto', // Center component for demo
//       position: 'relative', // Crucial for positioning overlays
//       overflow: 'hidden', // Hide anything spilling out
//       borderRadius: '10px', // Optional: rounded corners
//     },
//     reelContent: {
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       width: '100%',
//       height: '100%',
//       objectFit: 'cover', // Make image/video cover the area
//       zIndex: 1,
//     },
//     overlay: {
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       width: '100%',
//       height: '100%',
//       zIndex: 2, // Ensure overlays are above content
//       display: 'flex',
//       // Gradient overlay optional for better text visibility
//       // background: 'linear-gradient(to top, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 50%)',
//     },
//     // Simple top bar simulation (Ignoring status icons)
//     topNav: {
//        position: 'absolute',
//        top: '15px',
//        left: 0,
//        width: '100%',
//        display: 'flex',
//        justifyContent: 'center',
//        gap: '15px',
//        color: 'rgba(255, 255, 255, 0.7)',
//        fontWeight: 'bold',
//        fontSize: '16px',
//        textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
//     },
//      // Side bar for icons
//     sidebar: {
//       position: 'absolute',
//       bottom: '15px', // Position from bottom
//       right: '10px',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//     },
//     // Bottom info area
//     bottomInfo: {
//        position: 'absolute',
//        bottom: '15px',
//        left: '15px',
//        right: '80px', // Leave space for sidebar
//        color: 'white',
//        textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
//     },
//     username: {
//       fontWeight: 'bold',
//       fontSize: '16px',
//       marginBottom: '5px',
//       display: 'flex', // For potential verification tick etc.
//       alignItems: 'center',
//       gap: '5px'
//     },
//     caption: {
//       fontSize: '14px',
//       marginBottom: '10px',
//       lineHeight: '1.3',
//     },
//     soundInfo: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       fontSize: '13px',
//     }
//   };

//   return (
//     <div style={styles.reelContainer}>
//       {/* Background Video or Image */}
//       <img src={data.contentUrl} alt="Reel content background" style={styles.reelContent} />

//       {/* Overlays Container */}
//       <div style={styles.overlay}>

//         {/* Optional: Simplified Top Navigation */}
//         <div style={styles.topNav}>
//             {/* Could add Following/For You buttons here */}
//             <span>Following</span>
//             <span>For You</span>
//         </div>


//         {/* Bottom Info Overlay */}
//         <div style={styles.bottomInfo}>
//           <div style={styles.username}>
//             <span>{data.username}</span>
//             {/* Add verification tick SVG/image if needed */}
//           </div>
//           <div style={styles.caption}>
//             {data.caption}
//           </div>
//           <div style={styles.soundInfo}>
//              {/* Music Note Icon Placeholder */}
//              <span>🎵</span>
//              <span>{data.soundTitle}</span>
//           </div>
//         </div>

//         {/* Right Sidebar Overlay */}
//         <div style={styles.sidebar}>
//            {/* User Profile + Follow Button */}
//            <div style={{ position: 'relative', marginBottom: '20px' }}>
//               <img src={data.userImageUrl} alt="User profile" style={{ width: '50px', height: '50px', borderRadius: '50%', border: '2px solid white' }} />
//               {/* Placeholder Follow '+' icon */}
//               <div style={{
//                  position: 'absolute', bottom: '-8px', left: '50%', transform: 'translateX(-50%)',
//                  width: '20px', height: '20px', borderRadius: '50%', backgroundColor: 'red', color: 'white',
//                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', fontWeight: 'bold',
//                  border: '1px solid white'
//               }}>+</div>
//            </div>

//            {/* Action Icons */}
//            <IconPlaceholder label="❤️" count={data.likeCount} />
//            <IconPlaceholder label="💬" count={data.commentCount} />
//            <IconPlaceholder label="💾" count={data.saveCount} /> {/* Using save icon for bookmark */}
//            <IconPlaceholder label="➤" count={data.shareCount} /> {/* Using simple arrow for share */}

//            {/* Sound Icon */}
//            <SoundIconPlaceholder imageUrl={data.soundImageUrl} />
//         </div>

//       </div>
//     </div>
//   );
// }

// export default ReelDisplay;

// // Example Usage (in another component like App.js):
// // import ReelDisplay from './ReelDisplay';
// // function App() {
// //   return (
// //     <div className="App">
// //       <ReelDisplay />
// //     </div>
// //   );
// // }